import React from "react";
import { DayPicker } from "react-day-picker";
import { fr } from "date-fns/locale";
import "react-day-picker/dist/style.css";

const DateSelector = ({ label, value, onChange }) => {
  // Génère les années de 2020 à 2030 pour l'exemple
  const years = Array.from({ length: 11 }, (_, i) => 2020 + i);
  const months = [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
  ];

  const CustomDropdown = ({ value, options, onChange }) => {
    return (
      <select
        value={value}
        onChange={(e) => onChange(e)}
        className="border border-gray-300 text-gray-800 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-primary max-w-[100px] w-full"
      >
        {options.map((option, index) => (
          <option key={index} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
    );
  };

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden text-primary">
      <div className="bg-gradient-to-b from-[#f0f9ff] to-white p-2">
        <h3 className="text-md font-semibold text-center text-gray-800">
          {label}
        </h3>
      </div>

      <div className="px-6 py-4 w-full flex justify-center items-center">
        <DayPicker
          mode="single"
          selected={value}
          onSelect={onChange}
          locale={fr}
          className="rdp"
          captionLayout="dropdown"
          components={{ Dropdown: CustomDropdown }}
          modifiersClassNames={{
            selected: "bg-primary text-white rounded-full",
            today: " bg-muted/50 text-white !rounded-full",
          }}
          dayClassName={() =>
            "rounded-full w-10 h-10 flex items-center justify-center"
          }
          showOutsideDays
          disabled={{ before: new Date() }}
        />
      </div>
    </div>
  );
};

export default DateSelector;
